import {CURRENCY_INFO} from "src/utils/formatPrice";

export const formatRowPrice = (price, currency) => {
  if (Math.abs(price) < 0.00001) price = 0;
  const currencyInfo = CURRENCY_INFO[currency] || CURRENCY_INFO.unknown;
  return currencyInfo.render(
    (+price).toLocaleString([currencyInfo.locale], {
      maximumFractionDigits: currencyInfo.digits,
      minimumFractionDigits: currencyInfo.digits,
    })
  );
};
